// extracted by mini-css-extract-plugin
export default {"wrapper":"PatrolsRules-module_wrapper_ee0f4","rules":"PatrolsRules-module_rules_e7b2c","rule":"PatrolsRules-module_rule_e989c","header":"PatrolsRules-module_header_fa164"};